/**
 * Trạng thái của form
 */
export default {
  And: 1,
  Or: 2,
};
